// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Garbage: React.FC<{ width?: number; height?: number }> = ({ width = 11, height = 13 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 13">
            <path
                fill="currentColor"
                d="M3.36383929,0.541666667 L3.14285714,1.18181818 L0.785714286,1.18181818 C0.34375,1.18181818 0,1.52651515 0,1.96969697 C0,2.41287879 0.34375,2.75757576 0.785714286,2.75757576 L10.2142857,2.75757576 C10.65625,2.75757576 11,2.41287879 11,1.96969697 C11,1.52651515 10.65625,1.18181818 10.2142857,1.18181818 L7.85714286,1.18181818 L7.63616071,0.541666667 C7.53794643,0.221590909 7.24330357,0 6.89955357,0 L4.10044643,0 C3.75669643,0 3.46205357,0.221590909 3.36383929,0.541666667 Z M10.2142857,3.93939394 L0.785714286,3.93939394 L1.30133929,11.8920455 C1.35044643,12.5075758 1.86607143,13 2.47991071,13 L8.52008929,13 C9.13392857,13 9.64955357,12.5075758 9.69866071,11.8920455 L10.2142857,3.93939394 Z"
            />
        </svg>
    );
};

export default React.memo(Garbage);
